jQuery(document).ready(function ($) {
    "use strict";

    if ( $(document).width() >= 1050 ) {

        // If we are able to locate the fixed element
        if ( document.querySelector('.decade-timeline-1__decades') ) {
            // Assign the element we will want to fix on scroll to menu
            var menu = document.querySelector('.decade-timeline-1__decades');
        }

        // If menu exists
        if ( menu ) {

            // Calculate the postition of the menu on the page
            var menuPosition = menu.getBoundingClientRect();

            // Create a div on the page to house the CSS to fix the "jump"
            // When the menu becomes fixed instead of relative
            var placeholder = document.createElement('div');

            // Set the placeholder width an height, ready to be used
            placeholder.style.width = menuPosition.width + 'px';
            placeholder.style.height = menuPosition.height + 'px';

            // Is added to check whether the class is already active or not
            var isAdded = false;

            // Calculatr the height of the fixed header so we can work out the offset
            // for our sticky element top value
            var navHeight = $('.main-header').outerHeight();

            // This is the total offset of where we want the fixed nav to kick in for on scroll
            var calculatedTop = navHeight + menuPosition.top;

            // Listen for scrolling
            window.addEventListener('scroll', function() {

                // If we are past the offset and the fixed bar isn't already in position
                if ( window.pageYOffset >= calculatedTop && !isAdded ) {

                    // Add the sticky class to our element
                    menu.classList.add('decade-timeline-1__decades--sticky');

                    // Add the correct top offset for this sticky element to sit below the
                    // main navigation menu
                    $('.decade-timeline-1__decades').css('top', navHeight);

                    // Show the placeholder element so user's don't see a jump in height of the
                    // page when the relative element becomes fixed (thus reducing the height of the page)
                    menu.parentNode.insertBefore(placeholder, menu);

                    // Set is added to true so we know the element has this class already and is fixed
                    isAdded = true;

                } else if ( window.pageYOffset < menuPosition.top && isAdded ) {

                    // Remove sticky class from element
                    menu.classList.remove('decade-timeline-1__decades--sticky');

                    // Remove top offset as this element is now relatively positioned
                    $('.decade-timeline-1__decades').css('top', 0);

                    // Hide the placeholder element used to fix the height offset jump
                    menu.parentNode.removeChild(placeholder);

                    // Set is added to false so we know the element isn't currently fixed
                    isAdded = false;

                    // Remove active classes from links and return the first link to the active state
                    $('.decade-timeline-1__decade-link').removeClass('is-active');
                    $('.decade-timeline-1__decade-link:first').addClass('is-active');
                }
            });

            // On click we want to change which year is highlighted
            $('.decade-timeline-1__decade-link').on('click', function (e) {

                // Remove active from all links and add to this one
                $(this).siblings().removeClass('is-active');
                $(this).addClass('is-active');

            });
        }
    }
});
